import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-lds-ring',
    templateUrl: './lds-ring.component.html',
    styleUrls: ['./lds-ring.component.scss'],
    standalone: false
})
export class LdsRingComponent {

  constructor() { }

}
